export default {
  // App
  appName: "Flautreach",
  appTagline: "Social media scraping i filtrowanie zasilane przez AI",
  
  // Auth
  signIn: "Zaloguj się",
  signUp: "Zarejestruj się",
  email: "E-mail",
  password: "Hasło",
  confirmPassword: "Potwierdź hasło",
  signInBtn: "Zaloguj",
  createAccount: "Utwórz konto",
  forgotPassword: "Nie pamiętasz hasła?",
  resetPassword: "Resetuj hasło",
  resetDesc: "Wpisz swój e-mail, a wyślemy link do resetowania.",
  sendResetLink: "Wyślij link resetujący",
  cancel: "Anuluj",
  passwordsDontMatch: "Hasła nie są zgodne",
  passwordTooShort: "Hasło musi mieć co najmniej 8 znaków",
  accountCreated: "Konto utworzone! Sprawdź swoją skrzynkę, aby zweryfikować.",
  resetSent: "Link resetujący wysłany, jeśli ten e-mail istnieje!",
  emailPlaceholder: "ty@firma.pl",
  passwordPlaceholder: "••••••••",

  // Navigation
  myTasks: "Moje zadania",
  newTask: "Nowe zadanie",
  balance: "Saldo",
  visualization: "Wizualizacja",
  support: "Wsparcie",
  signOut: "Wyloguj się",

  // Tasks
  tasksList: "Zadania",
  newTaskTitle: "Nowe zadanie",
  tasksDesc: "Zarządzaj swoimi zadaniami scrapingu i filtrowania",
  noTasks: "Brak zadań",
  noTasksDesc: "Utwórz swoje pierwsze zadanie, aby zacząć zbierać dane z mediów społecznościowych.",
  createFirstTask: "Utwórz swoje pierwsze zadanie",
  
  // Task types
  taskType: "Typ zadania",
 
  
  // Task form
  taskName: "Nazwa zadania",
  taskNamePlaceholder: "np. Znajdź projektantów w Berlinie",
  keywords: "Słowa kluczowe / Zapytanie",
  keywordsPlaceholder: "np. web designer, UX designer, graphic designer",
  keywordsHint: "Oddziel słowa kluczowe przecinkami",
  platforms: "Platformy",
  selectPlatforms: "Wybierz platformy do scrapowania",
  filters: "Filtry",
  followersMin: "Min. obserwujących",
  followersMax: "Maks. obserwujących",
  postsMin: "Min. postów",
  postsMax: "Maks. postów",
  bioMinLength: "Min. długość opisu",
  privateAccounts: "Uwzględnij prywatne konta",
  hasLink: "Musi mieć link w opisie",
  keywordsInName: "Słowa kluczowe w nazwie",
  keywordsInBio: "Słowa kluczowe w opisie",
  keywordsInLink: "Słowa kluczowe w linku",
  language: "Język opisu",
  languageAll: "Wszystkie języki",
  languageEn: "Angielski",
  languagePl: "Polski",
  languageDe: "Niemiecki",
  createTask: "Utwórz zadanie",
  creating: "Tworzenie...",
  taskCreated: "Zadanie utworzone pomyślnie!",
  
  // Task statuses
  not_started: "Nie rozpoczęto",
  running: "Uruchomione",
  paused: "Wstrzymane",
  completed: "Zakończone",
  start: "Start",
  stop: "Stop",
  delete: "Usuń",
  deleteConfirm: "Usunąć to zadanie?",
  taskStarted: "Zadanie uruchomione",
  taskStopped: "Zadanie zatrzymane",
  taskDeleted: "Zadanie usunięte",
  results: "wyników",

  // Balance
  balanceTitle: "Saldo i kredyty",
  scrapingBalance: "Kredyty scrapingowe",
  aiBalance: "Kredyty analizy AI",
  topUp: "Doładuj",
  choosePlan: "Wybierz plan",
  customAmount: "Niestandardowa kwota",
  
  // Tariffs
  plansTitle: "Wybierz swój plan",
  planBasic: "Podstawowy",
  planPro: "Pro",
  planEnterprise: "Enterprise",
  planBasicPrice: "20 €",
  planProPrice: "50 €",
  planEnterprisePrice: "100 €",
  planBasicScraping: "1 000 kredytów scrapingowych",
  planBasicAI: "100 kredytów AI",
  planProScraping: "5 000 kredytów scrapingowych",
  planProAI: "500 kredytów AI",
  planEnterpriseScraping: "20 000 kredytów scrapingowych",
  planEnterpriseAI: "2 000 kredytów AI",
  customPlan: "Niestandardowe doładowanie",
  customPlanDesc: "Wybierz dokładnie tyle kredytów, ile potrzebujesz",
  scrapingCredits: "Kredyty scrapingowe",
  aiCredits: "Kredyty analizy AI",
  totalPrice: "Razem: €{price}",
  purchase: "Kup",
  purchaseSuccess: "Saldo doładowane pomyślnie!",
  
  // Visualization
  visualizationTitle: "Wizualizacja",
  selectTask: "Wybierz zadanie",
  visualizationType: "Typ wizualizacji",
  standardView: "Widok standardowy",
  aiView: "Widok z AI",
  standardViewDesc: "Pokaż profile z podstawowymi informacjami",
  aiViewDesc: "Analizuj profile z AI za pomocą niestandardowego promptu",
  profilesCount: "Liczba profili",
  aiPrompt: "Prompt AI",
  aiPromptPlaceholder: "np. Oceń ten profil [[FULLNAME]]: [[BIO]]. Sprawdź link: [[LINK]]",
  aiPromptHint: "Użyj [[FULLNAME]], [[BIO]], [[LINK]] jako zmiennych",
  startVisualization: "Rozpocznij wizualizację",
  visualizing: "Przetwarzanie...",
  profilesFound: "znalezionych profili",
  copy: "Kopiuj",
  save: "Zapisz",
  copied: "Skopiowano!",
  saved: "Zapisano!",

  // Support
  supportTitle: "Kontakt z pomocą techniczną",
  supportPlaceholder: "Opisz swój problem lub pytanie...",
  supportResponse: "Odpowiadamy zazwyczaj w ciągu 24 godzin w dni robocze.",
  sendMessage: "Wyślij wiadomość",
  supportEnterMsg: "Wpisz wiadomość",
  supportSent: "Otrzymaliśmy Twoją prośbę o pomoc! Odpowiemy na Twojego e-maila w ciągu 24 godzin.",

  // Common
  verifyBanner: "Zweryfikuj swój adres e-mail",
  verifyBanner2: "aby odblokować wszystkie funkcje.",
  resendVerify: "Wyślij ponownie e-mail weryfikacyjny",
  verifySent: "E-mail weryfikacyjny wysłany! Sprawdź skrzynkę.",
  langSwitch: "Język",
  planLabel: "Plan:",
  save: "Zapisz",
  cancel: "Anuluj",
  close: "Zamknij",
  
  // Errors
  unauthorized: "Brak autoryzacji",
  loginFailed: "Logowanie nieudane",
  regFailed: "Rejestracja nieudana",
  fetchFailed: "Nie udało się pobrać",
  createFailed: "Nie udało się utworzyć zadania",
  deleteFailed: "Nie udało się usunąć zadania",
  toggleFailed: "Nie udało się zmienić statusu zadania",
  topUpFailed: "Nie udało się doładować salda",
  supportFailed: "Nie udało się wysłać wiadomości",

  balanceAndCredits: "Zarządzaj swoimi kredytami",
visualizeAndAnalyze: "Przeglądaj i analizuj wyniki",
scrapingCreditsLabel: "🔄 Kredyty scrapingu",
aiCreditsLabel: "🤖 Kredyty AI",


clearAll: "Wyczyść wszystko",
clearAllConfirm: "Czy na pewno chcesz wyczyścić wszystkie pola?",

// pl.js
selectTaskToFilter: "Wybierz zadanie do filtrowania",
chooseExistingTask: "Wybierz istniejące zadanie scrapingu, aby zastosować filtry",
selectTask: "-- Wybierz zadanie --",
template: "Szablon",
aiFiltering: "Filtrowanie AI",
enable: "Włącz",
whatResult: "Jaki rezultat chcesz osiągnąć?",
describeFiltering: "Opisz, jakiego rodzaju filtrowania potrzebujesz...",
generateAIPrompt: "Generuj prompt AI",
availablePlaceholders: "Dostępne symbole zastępcze (kliknij, aby wstawić)",
testPrompt: "Testuj prompt na przykładowych profilach",
testPromptDesc: "Otwiera wizualizację z 5 losowymi profilami używając tego promptu",
matchCondition: "Warunek dopasowania",
matchConditionDesc: "Określ, które słowo oznacza pomyślne dopasowanie filtra",
wordToMatch: "Słowo do dopasowania",
wordToMatchPlaceholder: "np. zatwierdzony, poprawny, sukces",
searchScope: "Zakres wyszukiwania",
entireText: "Cały tekst",
firstLineOnly: "Tylko pierwsza linia",
creditsRequired: "Wymagane kredyty",
activeFiltersCredits: "Aktywne filtry × 0.3",
plusAI: "+ 1 (AI) kredytów",


// pl.js
platform: "Platforma",
step1ChooseNetwork: "Krok 1: Wybierz sieć społecznościową",
step2WhatToFind: "Krok 2: Co znaleźć na {platform}?",
scrapeAuthorPages: "Parsuj strony autorów",
scrapeAuthorPagesDesc: "Odwiedzaj profile autorów znalezionych postów, aby pobrać bio, obserwujących i kontakt.",
on: "ON",
off: "OFF",
whoToFind: "Kogo chcesz znaleźć?",
whoToFindPlaceholder: "Opisz kogo lub czego szukasz...",
editable: "edytowalny",
targetInserted: "cel wstawiony",
fillTargetAbove: "wypełnij cel powyżej",
generateWithAI: "Generuj z AI",
generating: "Generowanie...",
aiThinking: "AI myśli...",
searchQueries: "Zapytania wyszukiwania",
oneQueryPerLine: "Jedno zapytanie na linię.",
addedAutomatically: "dodawany automatycznie.",
clickToCheckGoogle: "Kliknij 🔗 aby sprawdzić w Google.",
enterSearchQueries: "Wprowadź zapytania...\njedno na linię",
google: "Google",
activeQuery: "aktywne zapytanie",
activeQueries: "aktywnych zapytań",
advancedSettings: "Ustawienia zaawansowane",
searchLanguage: "Język wyszukiwania",
popular: "Popularne",
allLanguages: "Wszystkie języki",
scrapingPeriod: "Okres scrapingu",
anyTimeSelected: "Wybrano dowolny czas",
periodsSelected: "wybranych okresów",
maxPagesPerQuery: "Maks. stron na zapytanie",
schedule: "Harmonogram",
oneTime: "Jednorazowo",
runsOnce: "Uruchamia się raz",
repeat: "Powtarzaj",
autoRuns: "Automatycznie",
daily: "Codziennie",
weekly: "Co tydzień",
monthly: "Co miesiąc",
every: "Co...",
queries: "zapytań",
pages: "stron",
periods: "okresów",
filtering: "Filtrowanie",
authorPages: "strony autorów",
clickOutsideToClose: "Kliknij poza lub Esc aby zamknąć",

// pl.js
additionalFilters: "Dodatkowe filtry",

// pl.js
edit: "Edytuj",
duplicate: "Duplikuj",
createFilteringTask: "Utwórz zadanie filtrowania",
moreActions: "Więcej akcji",
authorPagesLabel: "Strony autorów",
extraConfig: "Dodatkowa konfiguracja",
additionalSettings: "Ustawienia dodatkowe",
scrapeAuthorPages: "Parsuj strony autorów",
enabled: "Włączone",
disabled: "Wyłączone",

authorPagesEnabledDesc: "Jeśli otrzymamy link do posta/relacji w Google, pobierzemy informacje o autorze",
authorPagesDisabledDesc: "Jeśli otrzymamy link do posta/relacji w Google, nie będziemy ich sprawdzać",

scrapingTokensLabel: "Tokeny scrapingu",
aiTokensLabel: "Tokeny AI",
jobsBreakdown: "Podział zadań",
googleJobs: "Zadania Google",
scrapedLinks: "Zeskanowane linki",
found: "znaleziono",
jobsCompleted: "zadań ukończonych",
failed: "niepowodzeń",
completed: "Ukończone",
ofTotal: "z całości",
searchConfig: "Konfiguracja wyszukiwania",
maxPages: "Maks.",
created: "Utworzono",
started: "Rozpoczęto",
finished: "Zakończono",
notAuthenticated: "Nieuwierzytelniony",
failedToLoadTasks: "Nie udało się załadować zadań",
retry: "Spróbuj ponownie",
active: "aktywne",
total: "łącznie",
complete: "ukończone",
running: "uruchomione",
start: "Start",
stop: "Stop",
delete: "Usuń",
deleteConfirm: "Usunąć to zadanie?",
visualization: "Wizualizacja",
newTask: "Nowe zadanie",

// Статусы
not_started: "Nie rozpoczęto",
running: "Uruchomione",
paused: "Wstrzymane",
completed: "Ukończone",
done: "Gotowe",
failed: "Niepowodzenie",


// pl.js
failedToLoadImage: "Nie udało się załadować obrazu",
loadingImage: "Ładowanie obrazu...",
backToTasks: "Powrót do zadań",
visualization: "Wizualizacja",
browseResults: "Przeglądaj zeskanowane wyniki jeden po drugim",
configuration: "Konfiguracja",
selectTaskAndOptions: "Wybierz zadanie i opcje wizualizacji",
task: "Zadanie",
selectTask: "-- Wybierz zadanie --",
done: "gotowe",
type: "Typ",
standard: "Standardowy",
ai: "AI",
mode: "Tryb",
all: "Wszystkie",
random: "Losowe",
randomCount: "Liczba losowych",
aiPrompt: "Prompt AI",
aiPromptPlaceholder: "Opisz, co AI ma analizować...",
howItWorks: "Jak to działa",
howItWorksDesc: "Napisz prompt dla AI. Kliknij zmienne poniżej, aby je wstawić — zostaną zastąpione rzeczywistymi danymi z każdego wyniku.",
setFilterKeywordDesc: "Ustaw słowo kluczowe filtra, aby sprawdzić odpowiedź AI i zobaczyć PASSED lub FAILED dla każdego wyniku.",
availableVariables: "Dostępne zmienne (kliknij, aby wstawić)",
filterCheckKeyword: "Filtr: Sprawdź odpowiedź AI pod kątem słowa kluczowego",
filterCheckDesc: "Jeśli znaleziono słowo → PASSED, jeśli nie → FAILED",
keywordPlaceholder: "Słowo do znalezienia (np. tak, nie, zatwierdzony)",
firstLineOnly: "Tylko pierwsza linia",
fullText: "Pełny tekst",
subtype: "Podtyp",
startVisualization: "Rozpocznij wizualizację",
loading: "Ładowanie",
prev: "Poprzedni",
result: "Wynik",
of: "z",
loaded: "Załadowano",
allLoaded: "wszystko załadowane",
end: "Koniec",
next: "Następny",
reachedEnd: "Dotarłeś do końca! Wszystkie",
resultsLoaded: "wyników załadowanych",
loadingNextBatch: "Ładowanie następnej partii",
status: "Status",
copyRaw: "Kopiuj Raw",
aiAnalysis: "Analiza AI",
passed: "PASSED",
failed: "failed",
cost: "Koszt",
remaining: "Pozostało",
waitingForAI: "Oczekiwanie na odpowiedź AI",
retry: "Spróbuj ponownie",
openProfile: "Otwórz profil",
keyword: "Słowo kluczowe",
viaPost: "Przez post",
position: "Pozycja",
page: "Strona",
period: "Okres",
noResultsFound: "Nie znaleziono wyników",
noResultsDesc: "To zadanie nie ma jeszcze zeskanowanych wyników.",
arrowKeysHint: "Użyj strzałek ← → do nawigacji · Obrazy ładują się w tle",


// pl.js
instagramPost: "Post Instagram",
instagramPage: "Strona Instagram",
facebookPost: "Post Facebook",
facebookPage: "Strona Facebook",
linkedinPost: "Post LinkedIn",
result: "Wynik",
username: "Nazwa użytkownika",
caption: "Podpis",
bio: "Bio",
followers: "Obserwujący",
following: "Obserwowani",
posts: "Posty",
likes: "Polubienia",
comments: "Komentarze",
shares: "Udostępnienia",
content: "Treść",
headline: "Nagłówek",
description: "Opis",
category: "Kategoria",
email: "Email",
phone: "Telefon",
website: "Strona WWW",
address: "Adres",
name: "Nazwa",
url: "URL",
imageUrl: "URL obrazu",
postUrl: "URL posta",
pageUrl: "URL strony",
postCode: "Kod posta",
scrapedUrl: "URL scrapingu",
scrapedAt: "Zeskanowano",
foundViaUrl: "Znaleziono przez URL",
searchPosition: "Pozycja wyszukiwania",
viaPost: "Przez post",
status: "Status",
date: "Data",
noDescription: "Brak opisu",
postImage: "Obraz posta",
postContent: "Treść posta",
postInfo: "Informacje o poście",
engagement: "Zaangażowanie",
author: "Autor",
foundVia: "Znaleziono przez",
profile: "Profil",
pageStats: "Statystyki strony",
details: "Szczegóły",
contactInfo: "Kontakt",
published: "Opublikowano",
rawData: "Surowe dane",
rawJson: "Surowy JSON",
scraped: "Zeskanowano",

// pl.js
posts: "Posty",
pages: "Strony",
findInstagramPosts: "Znajdź posty i rolki Instagram",
findInstagramProfiles: "Znajdź profile i bio Instagram",
findFacebookPosts: "Znajdź publiczne posty Facebook",
findFacebookPages: "Znajdź strony i społeczności Facebook",
findLinkedInPosts: "Znajdź profesjonalne posty LinkedIn",
anyTime: "Dowolny czas",
pastYear: "Ostatni rok",
pastMonth: "Ostatni miesiąc",
pastWeek: "Ostatni tydzień",
past24h: "Ostatnie 24h",
pastHour: "Ostatnia godzina",

// Filter operators
// pl.js
filterOperators: {
  equals: "Równa się",
  contains: "Zawiera",
  not_contains: "Nie zawiera",
  contains_any_row: "Zawiera dowolny wiersz",
  not_contains_any_row: "Nie zawiera żadnego wiersza",
  is_not_empty: "Nie pusty",
  greater_than: "Większe niż",
  less_than: "Mniejsze niż",
  between: "Między",
  is_true: "Prawda",
  is_false: "Fałsz",
},

// Filter builder
filterBuilder: "Kreator filtrów",
addRule: "Dodaj regułę",
addRuleGroup: "Dodaj grupę reguł",
removeRule: "Usuń regułę",
noRules: "Nie dodano jeszcze reguł",
matchType: "Typ dopasowania",
matchAll: "WSZYSTKIE (AND)",
matchAny: "DOWOLNE (OR)",
selectField: "Wybierz pole",
selectOperator: "Wybierz operator",
enterValue: "Wprowadź wartość",
minValue: "Min",
maxValue: "Max",
clearAllRules: "Wyczyść wszystkie reguły",
previewResults: "Podgląd wyników",
rulesPreview: "Podgląd reguł",

// pl.js
filterBuilder: "Kreator filtrów",
filterBuilderDesc: "Zdefiniuj warunki filtrowania. Każdy wiersz to jeden warunek.",
addRule: "Dodaj warunek",
clearAllRules: "Wyczyść",
selectField: "Pole",
selectOperator: "Operator",
enterValue: "Wartość",
noValueNeeded: "Bez wartości",
minValue: "Min",
maxValue: "Max",
allConditions: "WSZYSTKIE warunki",
anyCondition: "DOWOLNY warunek",
allConditionsDesc: "Wynik musi spełniać KAŻDY z warunków",
anyConditionDesc: "Wynik musi spełniać CO NAJMNIEJ JEDEN warunek",
singleRule: "Jeden warunek",
noRules: "Brak warunków",
rules: "warunków",

// pl.js
taskName: "Nazwa zadania",
createFilteringTask: "Utwórz zadanie filtrowania",
selectTaskFirst: "Najpierw wybierz zadanie",
saving: "Zapisywanie",

filtering: "Filtrowanie",
filteringConfig: "Konfiguracja filtrowania",
aiFilteringEnabled: "Filtrowanie AI włączone",
aiFilteringDisabled: "Filtrowanie AI wyłączone",
passKeyword: "Hasło",
checkFirstRowOnly: "Sprawdź tylko pierwszy wiersz",
filterRules: "Reguły filtrowania",
equals: "równa się",
contains: "zawiera",
doesNotContain: "nie zawiera",
containsAny: "zawiera którekolwiek",
containsAnyOf: "zawiera którekolwiek z",
valuesCount: "wartości",
moreCount: "+{{count}} więcej",
excludesAll: "wyklucza wszystkie",
excludesAllOf: "wyklucza wszystkie z",
showAll: "pokaż wszystkie",
showLess: "pokaż mniej",
isNotEmpty: "nie jest puste",
greaterThan: "> {{val}}",
lessThan: "< {{val}}",
between: "{{min}} — {{max}}",
isTrue: "jest prawdą",
isFalse: "jest fałszem",
filteringResults: "Wyniki filtrowania",
totalRuns: "Łącznie",
passedFilter: "Przeszło",
rejectedFilter: "Odrzucone",
failedFilter: "Błędy",
doneFilter: "gotowe",
runningFilter: "w trakcie",
pendingFilter: "oczekuje",
ofTotal: "z całości",
aiResults: "Wyniki AI",
aiPassed: "przeszło",
aiRejected: "odrzucone",
recentRuns: "Ostatnie uruchomienia",
showAllRuns: "Pokaż wszystkie",
noFilteringData: "Brak danych filtrowania",

"forceStop": {
      "aitokens": {
        "title": "Задача остановлена - нет AI токенов",
        "message": "Бро! Закончились AI токены. Пополни баланс! 💰",
        "action": "Купить AI токены",
        "details": "Задача: {{taskId}} | Нужно: {{required}} | Есть: {{available}}"
      },
      "scrapingtokens": {
        "title": "Задача остановлена - нет токенов скрапинга",
        "message": "Бро! Токены скрапинга кончились. Пополни кошелёк! 🚀",
        "action": "Купить токены скрапинга",
        "details": "Задача: {{taskId}} | Нужно: {{required}} | Есть: {{available}}"
      }
    },
    "wallet": {
    "tokenTypes": {
      "ai": "Tokeny AI",
      "scraping": "Tokeny scrapingowe"
    }
  },

// pl.js
noAITokensTitle: "Brak tokenów AI",
noAITokensMessage: "Bracie, skończyły Ci się tokeny AI. Doładuj konto.",
noScrapingTokensTitle: "Brak tokenów scrapingu",
noScrapingTokensMessage: "Bracie, skończyły Ci się tokeny scrapingu. Doładuj konto.",
noAITokens: "Brak AI",
noScrapingTokens: "Brak scrapingu",
topUp: "Doładuj",

fromScratch: "From scratch",
fromScratchDesc: "Configure all parameters manually",
fromTemplate: "From template",
fromTemplateDesc: "Pick a preset and adjust it",
chooseTemplate: "Choose a template",
taskSelectionDesc: "Start from scratch or use a ready-made template",
continue: "Continue",

verifyInProgress: "Weryfikacja adresu email...",
verifySuccess: "Adres email zweryfikowany pomyślnie!",
verifySuccessTitle: "Email zweryfikowany!",
verifyError: "Weryfikacja nie powiodła się",
verifyErrorTitle: "Weryfikacja nieudana",
verifyInvalidToken: "Nieprawidłowy link weryfikacyjny",
goToLogin: "Przejdź do logowania",

resetPassword: "Resetuj hasło",
resetPasswordDesc: "Wprowadź nowe hasło",
newPassword: "Nowe hasło",
newPasswordPlaceholder: "Wprowadź nowe hasło",
confirmPassword: "Potwierdź hasło",
confirmPasswordPlaceholder: "Potwierdź nowe hasło",
resetPasswordBtn: "Resetuj hasło",
passwordResetSuccess: "Hasło zresetowane!",
passwordResetSuccessDesc: "Twoje hasło zostało pomyślnie zresetowane. Możesz się teraz zalogować używając nowego hasła.",
passwordResetError: "Resetowanie hasła nie powiodło się",
invalidResetLink: "Nieprawidłowy link",
invalidResetLinkDesc: "Ten link do resetowania hasła jest nieprawidłowy lub wygasł.",

// pl.js
verifyEmailToLogin: "Zweryfikuj swój email przed zalogowaniem. Sprawdź skrzynkę odbiorczą.",
checkInbox: "Sprawdź skrzynkę odbiorczą i kliknij link weryfikacyjny.",
resendVerificationBtn: "Wyślij ponownie email weryfikacyjny",
backToLogin: "Powrót do logowania",
enterEmailFirst: "Najpierw wprowadź swój email",











































































defaultPrompts: {
  instagram_posts: 'Check instagram post with text "[[TEXT]]". \n\n Is it about cats and dogs? \n\n Write only "yes" or "no" on the first row, explain your decision on second.',
  instagram_pages: 'Analyze this Instagram page. Bio: "[[BIO]]". \n\n Is this a business account? \n\n Answer "yes" or "no" on first line, then explain.',
  facebook_posts: 'Check Facebook post: "[[TEXT]]". \n\n Is it promotional content?  \n\nAnswer only "yes" or "no" on first row, explain on second.',
  linkedin_posts: 'Analyze LinkedIn post: "[[TEXT]]".  \n\nIs it a job posting?  \n\nWrite "yes" or "no" on first line, then explain.',
  facebook_pages: 'Check this Facebook page. About: "[[BIO]]". \n\n Is it a company page? \n\n Answer "yes" or "no" on first row, explain on second.',
  default: 'Analyze this data. \n\n  Is it about jobs?  \n\nWrite "yes" or "no" on first line based on your analysis, then explain.',

  default_pass_word: 'yes'
},

referralsPage: {
    loading: "Ładowanie danych poleceń...",
    headerTitle: "Program poleceń",
    name: "Program poleceń",
    headerSubtitle: "Udostępnij swój link i zarabiaj na płatnościach poleconych",
    linkCardTitle: "Twój link polecający",
    linkCardDescription: "Udostępnij ten link innym. Gdy się zarejestrują, otrzymasz 30% prowizji od ich płatności.",
    referralId: "ID polecenia",
    created: "Utworzono",
    copy: "Skopiuj",
    copied: "✓ Skopiowano!",
    createButton: "🔗 Wygeneruj link polecający",
    creating: "Tworzenie...",
    totalReferrals: "Wszystkie polecenia",
    active: "aktywne",
    totalEarned: "Łącznie zarobione",
    fromReferralsPayments: "Z płatności poleconych",
    totalPayments: "Wszystkie płatności",
    successfulPayments: "Udane płatności",
    tableTitle: "Twoje polecenia",
    tableEmpty: "Brak poleceń. Udostępnij swój link, aby zacząć zarabiać!",
    userColumn: "Użytkownik",
    registeredColumn: "Zarejestrowany",
    paymentsColumn: "Płatności",
    earnedColumn: "Łącznie zarobione",
    userLabel: "Użytkownik",
    registeredLabel: "Zarejestrowany",
    paymentsLabel: "Płatności",
    earnedLabel: "Zarobione",
    previous: "← Poprzednia",
    next: "Następna →",
    pageOf: "Strona {page} z {totalPages}",
    failedToLoad: "Nie udało się załadować danych poleceń",
    failedToCreate: "Nie udało się utworzyć linku polecającego",
    failedToDelete: "Nie udało się usunąć linku polecającego",
    deleteConfirmation: "Usunąć ten link polecający?",
    errorDefault: "Nie udało się załadować danych",
    dateLocale: "pl-PL",
    currency: "PLN"
  },

  PageHeader: {
    scrapingLabel: '🔄 Scrapowanie',
    aiLabel: '🤖 AI',
  },

  supportModal: {
      supportTitle: "Wsparcie",
      supportHelp: "Możesz skontaktować się z pomocą techniczną przez e-mail support@flautreach.com lub użyć tego formularza",
      supportPlaceholder: "Opisz swój problem lub pytanie...",
      supportResponse: "Zazwyczaj odpowiadamy w ciągu 24 godzin roboczych",
      sendMessage: "Wyślij wiadomość",
      supportEnterMsg: "Wprowadź wiadomość",
      supportSent: "Zgłoszenie wysłane! Odpowiemy na TWÓJ E-MAIL w ciągu 24 godzin.",
  },

  sidebar: {
     myTasks: "Moje zadania",
    newTask: "Nowe zadanie",
    balance: "Saldo",
    visualization: "Wizualizacja",
    support: "Wsparcie",
    referrals: 'Polecenia',
    signOut: "Wyloguj",
  },

  balancePage: {
    headerTitle: "Saldo i tokeny",
    headerSubtitle: "Doładuj saldo i wymień tokeny",
    balanceLabel: "💵 Saldo",
    scrapingTokensLabel: "🔄 Tokeny scrapingowe",
    aiTokensLabel: "🤖 Tokeny AI",
    usdToTokensRate: "1 $ = {rate} tokenów",
    aiTokensRate: "${price} = 1 000 000 tokenów",
    aiTokensFormula: "Wydane tokeny AI = tokeny_wejściowe + 2×tokeny_wyjściowe",
    aiTokensFormulaDesc: "Zużycie tokenów AI jest obliczane jako suma tokenów wejściowych i dwukrotności tokenów wyjściowych",
    whatYouCanDo: "Co możesz zrobić",
    whatYouCanDoDesc: "Alternatywne sposoby wykorzystania tokenów",
    with200Scraping: "Za 200 tokenów scrapingowych →",
    with1MAI: "Za 1 000 000 tokenów AI →",
    or: "Lub",
    tokensPerPage: "@{tokens} tokenów/strona",
    tokensPerPost: "@{tokens} tokenów/post",
    tokensPerReq: "~{tokens} tokenów/zapytanie",
    googlePages: "Strony Google",
    linkedinPosts: "Posty LinkedIn",
    instagramPosts: "Posty Instagram",
    facebookPages: "Strony Facebook",
    smallContext: "Krótki kontekst",
    mediumContext: "Średni kontekst",
    largeContext: "Długi kontekst",
    topUpTitle: "💵 Doładuj",
    topUpDescCrypto: "Płać kryptowalutą i zyskaj 20% bonusu",
    topUpDescCard: "Karta kredytowa/debetowa",
    amountLabel: "Kwota ($)",
    topUpBtn: "Doładuj ${amount}",
    processing: "Przetwarzanie...",
    continueBtn: "Kontynuuj →",
    backBtn: "← Wstecz",
    cancelBtn: "Anuluj",
    confirmAmount: "Potwierdź kwotę",
    youPay: "PŁACISZ",
    youGet: "OTRZYMUJESZ",
    equalsTo: "= {scraping} tokenów scrapingowych lub {ai} tokenów AI",
    cryptoBonus: "🎁 Płać kryptowalutą → otrzymaj ${amount} (+20%)",
    choosePaymentMethod: "Wybierz metodę płatności",
    cardLabel: "Karta",
    cardNotAvailable: "Chwilowo niedostępne",
    cryptoLabel: "Krypto",
    cryptoDesc: "BTC, ETH, USDT · 10-30 min",
    cryptoBonusBadge: "+20%",
    invoiceCreated: "✅ Faktura utworzona!",
    clickToPay: "Kliknij tutaj, aby zapłacić",
    minimumTopUpError: "Minimalna kwota doładowania to ${min}. Twoja kwota: ${amount}. Potrzebujesz jeszcze ${diff}.",
    cardNotWorkingError: "Płatności kartą są jeszcze niedostępne. Spróbuj płatności kryptowalutą, aby zyskać 20% bonusa.",
    invalidAmount: "Wprowadź poprawną kwotę",
    topUpFailed: "Nie udało się utworzyć intencji płatności",
    invoiceFailed: "Nie udało się utworzyć faktury",
    presetAmounts: [5, 20, 50, 100, 200],
    convertTitle: "🔄 Konwertuj",
    convertDesc: "Konwertuj saldo na tokeny lub wymieniaj tokeny między sobą",
    fromLabel: "Z",
    toLabel: "DO",
    balanceOption: "Saldo (${balance})",
    scrapingOption: "Scrapingowe ({tokens})",
    aiOption: "AI ({tokens})",
    scrapingTokensOption: "Tokeny scrapingowe",
    aiTokensOption: "Tokeny AI",
    convertBtn: "Wymień",
    converting: "Wymienianie...",
    confirmBtn: "Potwierdź",
    convertConfirmBalance: "Wymienić ${amount} → {tokens} tokenów {type}?",
    convertConfirmTokens: "Wymienić {fromAmount} {fromType} → {toAmount} {toType}?",
    convertSuccess: "✅ Tokeny wymienione pomyślnie!",
    convertFailed: "Wymiana nie powiodła się",
    approxUsd: "≈ ${cost}",
    dollarPrefix: "$",
    bonus:'bonus'
  },

visualizationPage: {
  // Header
  visualization: "Wizualizacja",
  browseResults: "Przeglądaj wyniki scrapowania jeden po drugim",
  backToTasks: "Powrót do zadań",

  // Configuration
  configuration: "Konfiguracja",
  selectTaskAndOptions: "Wybierz zadanie i opcje wizualizacji",
  task: "Zadanie",
  selectTask: "-- Wybierz zadanie --",
  done: "gotowych",
  type: "Typ",
  standard: "Standardowy",
  ai: "AI",
  mode: "Tryb",
  all: "Wszystkie",
  random: "Losowo",
  randomCount: "Liczba losowych",

  // AI Prompt
  aiPrompt: "Prompt AI",
  aiPromptPlaceholder: "Opisz, co AI ma przeanalizować...",
  howItWorks: "Jak to działa",
  howItWorksDesc: "Wpisz prompt dla AI. Kliknij zmienne poniżej, aby je wstawić — zostaną zastąpione rzeczywistymi danymi z każdego wyniku.",
  setFilterKeywordDesc: "Ustaw słowo kluczowe filtra, aby sprawdzić odpowiedź AI i zobaczyć status PASSED lub FAILED dla każdego wyniku.",
  availableVariables: "Dostępne zmienne (kliknij, aby wstawić)",
  filterCheckKeyword: "Filtr: Sprawdź odpowiedź AI pod kątem słowa kluczowego",
  filterCheckDesc: "Jeśli znaleziono słowo kluczowe → POZYTYWNIE, jeśli nie → NEGATYWNIE",
  keywordPlaceholder: "Słowo kluczowe do znalezienia (np. tak, nie, zatwierdzono)",
  firstLineOnly: "Tylko 1. linia",
  fullText: "Pełny tekst",

  // Subtype
  subtype: "Podtyp",

  // Start button
  startVisualization: "Rozpocznij wizualizację",
  loading: "Ładowanie...",

  // Navigation
  prev: "Poprzedni",
  result: "Wynik",
  of: "z",
  loaded: "Załadowano",
  allLoaded: "wszystkie załadowane",
  end: "Koniec",
  next: "Następny",
  reachedEnd: "Dotarłeś do końca! Wszystkie wyniki zostały załadowane.",
  resultsLoaded: "wyniki załadowane",
  loadingNextBatch: "Ładowanie następnej partii...",

  // Status
  status: "Status",
  openProfile: "Otwórz profil",
  keyword: "Słowo kluczowe",
  viaPost: "Przez post",
  position: "Pozycja",
  page: "Strona",
  period: "Okres",

  // AI Analysis
  aiAnalysis: "Analiza AI",
  passed: "POZYTYWNY",
  failed: "NEGATYWNY",
  cost: "Koszt",
  remaining: "Pozostało",
  waitingForAI: "Oczekiwanie na odpowiedź AI...",
  retry: "Ponów",

  // No results
  noResultsFound: "Nie znaleziono wyników",
  noResultsDesc: "To zadanie nie ma jeszcze wyników scrapowania.",

  // Navigation hint
  arrowKeysHint: "Użyj strzałek ← → do nawigacji · Obrazy ładują się w tle",

  // Image
  failedToLoadImage: "Nie udało się załadować obrazu",
  loadingImage: "Ładowanie obrazu...",

  // Errors
  fetchFailed: "Nie udało się pobrać danych",

  // Filter statuses (for filtering tasks)
  filterConfig: "Konfiguracja filtra",
  regularFilterStatus: "Status filtra zwykłego",
  aiFilterStatus: "Status filtra AI",
  allStatus: "Wszystkie",
  passedStatus: "✅ Zatwierdzone",
  rejectedStatus: "❌ Odrzucone",
  noAIStatus: "Brak AI",
  aiNotEnabled: "Filtrowanie AI nie jest włączone dla tego zadania",

  // Filter result badges
  passedFilter: "✅ Zatwierdzone przez filtr",
  rejectedFilter: "❌ Odrzucone przez filtr",
  aiPassedFilter: "🤖 Zatwierdzone przez AI",
  aiRejectedFilter: "🤖 Odrzucone przez AI",
  noAIFilter: "🤖 Brak filtra AI",
  aiFilterResponse: "🤖 Odpowiedź filtra AI",

  // Scraping status filter
  resultStatus: "Status wyniku",
  success: "Sukces",
  failedStatus: "Niepowodzenie",

  // Open URL
  openURL: "Otwórz URL ↗",

  // Raw data
  copyRaw: "Kopiuj surowe dane",

  // Default filter pass word
  defaultPassWord: "tak",
  dataSource: "Źródło danych",
  scrapingData: "Scraping danych",
  filteringData: "Filtrowanie danych",
},




defaultPrompts: {
  instagram_posts: 'Sprawdź post na Instagramie o treści "[[TEXT]]". \n\n Czy dotyczy kotów i psów? \n\n Napisz tylko "tak" lub "nie" w pierwszej linii, wyjaśnij w drugiej.',
  instagram_pages: 'Przeanalizuj tę stronę na Instagramie. Bio: "[[BIO]]". \n\n Czy to konto firmowe? \n\n Odpowiedz "tak" lub "nie" w pierwszej linii, a następnie wyjaśnij.',
  facebook_posts: 'Sprawdź post na Facebooku: "[[TEXT]]". \n\n Czy to treść promocyjna? \n\n Odpowiedz tylko "tak" lub "nie" w pierwszej linii, wyjaśnij w drugiej.',
  linkedin_posts: 'Przeanalizuj post na LinkedIn: "[[TEXT]]". \n\n Czy to oferta pracy? \n\n Napisz "tak" lub "nie" w pierwszej linii, a następnie wyjaśnij.',
  facebook_pages: 'Sprawdź tę stronę na Facebooku. O stronie: "[[STATUS]]". \n\n Czy to strona firmowa? \n\n Odpowiedz "tak" lub "nie" w pierwszej linii, wyjaśnij w drugiej.',
  default: 'Przeanalizuj te dane. \n\n Czy dotyczą pracy? \n\n Napisz "tak" lub "nie" w pierwszej linii na podstawie analizy, a następnie wyjaśnij.',
  default_pass_word: 'tak',
},

taskSelectionPage: {
  levelGoal: 'Cele',
  levelForWhom: 'Dla kogo',
  levelNiche: 'Nisza',
  levelSetup: 'Konfiguracja',
  newTaskTitle: 'Utwórz zadanie',
  taskSelectionDesc: "Zacznij od zera lub wybierz gotowy szablon",
  fromScratch: "Od zera",
  fromScratchDesc: "Skonfiguruj ręcznie",
  fromTemplate: "Z szablonu",
  fromTemplateDesc: "Wybierz szablon",
  templatesLabel: 'Szablony',
  cancel: "Anuluj",
  continue: "Kontynuuj",
  useTemplate: "Użyj szablonu",

  orUseGeneralTemplate: "lub użyj ogólnego szablonu dla",
coversBasics: "Obejmuje podstawy bez dodatkowej konfiguracji",
orUseGeneralTemplate: "Użyj ogólnego szablonu",

backButton: "Wstecz"
},



createTaskPage: {
    taskType: "Typ zadania",
  newTaskTitle: "Nowe zadanie",
  tasksDesc: "Zarządzaj zadaniami scrapowania i filtrowania",
  clearAll: "Wyczyść wszystko",
  taskName: "Nazwa zadania",
  taskNamePlaceholder: "np. Znajdź projektantów w Berlinie",

   scrapingLabel: "Scrapowanie",
  filteringLabel: "Filtrowanie",
  scrapingFilteringLabel: "Scrapowanie + Filtrowanie",
  scrapingDesc: "Zbierz informacje z mediów społecznościowych",
  filteringDesc: "Filtruj zebrane informacje",
  scrapingFilteringDesc: "Zbierz i filtruj",

  
    scraping: {
      // Wybór platformy
      reels: "Relki",
  findInstagramReels: "Znajdź Instagram Reels",
      platform: "Platforma",
      step1ChooseNetwork: "Krok 1: Wybierz sieć społecznościową",
      step2WhatToFind: "Krok 2: Wybierz cel dla platformy {platform}?",
      
      // Podtypy
      posts: "Posty",
      pages: "Profile",
      findInstagramPosts: "Znajdź posty i reels na Instagramie",
      findInstagramProfiles: "Znajdź profile i bio na Instagramie",
      findFacebookPosts: "Znajdź publiczne posty na Facebooku",
      findFacebookPages: "Znajdź strony firmowe i społeczności na Facebooku",
      findLinkedInPosts: "Znajdź profesjonalne posty na LinkedIn",
      
      // Przełącznik stron autorów
      scrapeAuthorPages: "Scrapuj strony autorów",
      scrapeAuthorPagesDesc: "Odwiedź profile autorów znalezionych postów, aby wyodrębnić bio, obserwujących i dane kontaktowe.",
      on: "WŁ.",
      off: "WYŁ.",
      
      // Kogo znaleźć
      whoToFind: "Kogo chcesz znaleźć?",
      whoToFindPlaceholder: "Opisz, kogo lub czego szukasz...",
      
      // Podpowiedź AI
      aiPromptLabel: "Podpowiedź AI do generowania zapytań",
      generateWithAI: "Generuj z AI",
      generating: "Generowanie...",
      resetPrompt: "Przywróć domyślne",

      // Domyślna podpowiedź, gdy nie wybrano platformy
      defaultPrompt: 'Napisz 30 odpowiednich słów kluczowych lub fraz wyszukiwania dla "{target}" w mediach społecznościowych. Wypisz tylko wyniki w nowych wierszach. Nie używaj numerów, punktorów ani markdown.',

      // Domyślne podpowiedzi dla platform
      defaultPrompts: {
        instagram_posts: 'Jakie słowa mogą pojawić się w postach i reels na Instagramie związanych z "{target}". Napisz 30 odpowiednich słów kluczowych lub krótkich fraz. Wypisz tylko wyniki w nowych wierszach. Nie używaj numerów, punktorów ani markdown.',
        instagram_pages: 'Jakie słowa mogą pojawić się w postach i biografii osoby na Instagramie, która odpowiada koncepcji "{target}". Napisz 30 odpowiednich słów kluczowych lub krótkich fraz. Wypisz tylko wyniki w nowych wierszach. Nie używaj numerów, punktorów ani markdown.',
        facebook_posts: 'Jakie słowa mogą pojawić się w publicznych postach na Facebooku osoby lub strony związanej z koncepcją "{target}". Napisz 30 odpowiednich słów kluczowych lub krótkich fraz. Wypisz tylko wyniki w nowych wierszach. Nie używaj numerów, punktorów ani markdown.',
        facebook_pages: 'Jakie słowa mogą pojawić się w nazwie, opisie i postach strony na Facebooku związanej z koncepcją "{target}". Napisz 30 odpowiednich słów kluczowych lub krótkich fraz. Wypisz tylko wyniki w nowych wierszach. Nie używaj numerów, punktorów ani markdown.',
        linkedin_posts: 'Jakie słowa mogą pojawić się w postach i profilu na LinkedIn profesjonalisty związanego z koncepcją "{target}". Napisz 30 odpowiednich słów kluczowych lub krótkich fraz (stanowiska, umiejętności, branże). Wypisz tylko wyniki w nowych wierszach. Nie używaj numerów, punktorów ani markdown.',
      },
      
      // Plakietki wymagane/opcjonalne
      required: "Wymagane",
      optional: "Opcjonalne",

      // Stany synchronizacji podpowiedzi AI
      autoSync: "Autosynchronizacja",
      manualMode: "Tryb ręczny",
      resetPrompt: "Przywróć domyślne",

      // Zapytania wyszukiwania
      searchQueries: "Zapytania wyszukiwania",
      oneQueryPerLine: "Jedno zapytanie na wiersz.",
      addedAutomatically: "dodawane automatycznie",
      clickToCheckGoogle: "Kliknij 🔗, aby przetestować w Google.",
      enterSearchQueries: "Wprowadź zapytania...\njedno na linię",
      google: "Google",
      activeQuery: "aktywne zapytanie",
      activeQueries: "aktywne zapytania",
      
      // Ustawienia zaawansowane
      advancedSettings: "Zaawansowane",
      searchLanguage: "Język wyszukiwania",
      popular: "Popularne",
      allLanguages: "Wszystkie języki",
      scrapingPeriod: "Okres scrapowania",
      anyTimeSelected: "Wybrano dowolny czas",
      periodsSelected: "Wybrane okresy:",
      maxPagesPerQuery: "Maksymalna stron na zapytanie",
      
      // Opcje okresu
      anyTime: "Dowolny czas",
      pastYear: "Ostatni rok",
      pastMonth: "Ostatni miesiąc",
      pastWeek: "Ostatni tydzień",
      past24h: "Ostatnie 24h",
      pastHour: "Ostatnia godzina",
      
      // Harmonogram
      schedule: "Harmonogram",
      oneTime: "Jednorazowo",
      runsOnce: "Uruchamia się raz",
      repeat: "Powtarzaj",
      autoRuns: "Autouruchamianie",
      daily: "Codziennie",
      weekly: "Co tydzień",
      monthly: "Co miesiąc",
      every: "Co...",
      
      // Podział kredytów
      queries: "zapytania",
      pages: "Profile",
      periods: "okresy",
      filtering: "Filtrowanie",
      authorPages: "Profile autorów",
      
      // Etykietki pomocy
      clickOutsideToClose: "Kliknij na zewnątrz lub naciśnij Esc, aby zamknąć",
      
      // Treść pomocy
      help: {
        whoToFind: {
          title: "Jak opisać cel?",
          tips: [
            "Bądź konkretny: stanowisko, branża, lokalizacja",
            "Przykład: 'Kierownicy marketingu w Londynie'",
            "Przykład: 'Inżynierowie oprogramowania w Google'",
            "Używaj naturalnego języka — wygenerujemy zapytania"
          ],
          links: [
            { text: "📖 Przewodnik po zapytaniach", url: "#" },
            { text: "🎯 Najlepsze praktyki targetowania", url: "#" }
          ]
        },
        aiPrompt: {
          title: "Wskazówki dotyczące podpowiedzi AI",
          tips: [
            "Napisz instrukcje dla AI, aby wygenerować zapytania wyszukiwania",
            "Użyj {target} — zostanie zastąpione twoim opisem celu",
            "Bądź konkretny: poproś o słowa kluczowe, frazy, warianty",
            "AI zwróci jedno zapytanie na wiersz"
          ],
          links: []
        },
        keywords: {
          title: "Wskazówki dotyczące zapytań wyszukiwania",
          tips: [
            "Jedno zapytanie na wiersz = 1 kredyt za stronę",
            "Używaj cudzysłowów dla dokładnych fraz: 'kierownik marketingu'",
            "site: filtr dodawany automatycznie",
            "Kliknij 🔗, aby podejrzeć w Google"
          ],
          links: [
            { text: "📖 Zaawansowane operatory wyszukiwania", url: "#" }
          ]
        },
        platform: {
          title: "Przewodnik po platformach",
          tips: [
            "Krok 1: Wybierz sieć społecznościową",
            "Krok 2: Wybierz, co znaleźć (Profile lub Posty)",
            "Profile Instagram: Znajdź profile, uzyskaj bio i kontakt",
            "Profile Facebook: Profile firmowe i społeczności",
            "Posty Facebook: Publiczne posty i treści",
            "Posty LinkedIn: Treści profesjonalne"
          ],
          links: [
            { text: "📖 Porady dotyczące platform", url: "#" }
          ]
        },
        instagramPagesInfo: {
          title: "Scrapuj profile autorów",
          tips: [
            "Gdy włączone: Jeśli znajdziemy post/reel, odwiedzimy profil autora",
            "Wyodrębnia: bio, liczbę obserwujących, kontakt, linki zewnętrzne",
            "Przydatne do: badania influencerów, generowania leadów, analizy konkurencji",
            "⚠️ Zużywa dodatkowe kredyty za każdą odwiedzoną stronę autora"
          ],
          links: []
        },
        scrapingPeriod: {
          title: "Zakres czasu",
          tips: [
            "Wybierz wiele zakresów",
            "Dowolny czas = brak ograniczeń",
            "Więcej zakresów = więcej kredytów"
          ],
          links: []
        },
        schedule: {
          title: "Harmonogram",
          tips: [
            "Jednorazowo: uruchamia się raz",
            "Powtarzaj: automatyczne uruchamianie w odstępach"
          ],
          links: [
            { text: "📖 Przewodnik automatyzacji", url: "#" }
          ]
        }
      },
      
      // Akcje
      createTask: "Utwórz zadanie",
      creating: "Tworzenie...",
      cancel: "Anuluj",
      estimatedTokens: "⚡ Szacowane tokeny (około)"
    },


    filtering: {
      missingPlaceholdersError: "Prompt AI musi zawierać co najmniej jeden placeholder. Dostępne: {missing}",
missingPlaceholdersWarning: "Dodaj co najmniej jeden placeholder:",

  reelsMetrics: "Metryki i zaangażowanie rolek",
  minViews: "Min. wyświetleń",
  maxViews: "Maks. wyświetleń",
  minViewsPlaceholder: "0",
  maxViewsPlaceholder: "Brak limitu",
  minLikes: "Min. polubień",
  maxLikes: "Maks. polubień",
  minLikesPlaceholder: "0",
  maxLikesPlaceholder: "Brak limitu",
  minComments: "Min. komentarzy",
  maxComments: "Maks. komentarzy",
  minCommentsPlaceholder: "0",
  maxCommentsPlaceholder: "Brak limitu",
  minEngagementRate: "Min. wskaźnik zaangażowania (%)",
  maxEngagementRate: "Maks. wskaźnik zaangażowania (%)",
  minEngagementRatePlaceholder: "0",
  maxEngagementRatePlaceholder: "Brak limitu",
  engagementFormula: "Formuła zaangażowania",
  standardFormula: "Standardowa: polubienia/wyświetlenia + (komentarze×2)/wyświetlenia",
  simpleFormula: "Prosta: polubienia/wyświetlenia",
  sortBy: "Sortuj wyniki według",
  byEngagement: "Wskaźnika zaangażowania",
  byLikes: "Liczby polubień",
  byComments: "Liczby komentarzy",
  topReelsCount: "Liczba najlepszych rolek do wybrania",
  topReelsCountPlaceholder: "30",
  generateSummary: "Generuj podsumowanie AI najlepszych rolek",
  generateSummaryDesc: "Zostanie utworzone podsumowanie generowane przez AI, analizujące wzorce, trendy i wnioski z wybranych rolek",
  
  // Wybór zadania
  selectTaskToFilter: "Wybierz zadanie do filtrowania",
  chooseExistingTask: "Wybierz istniejące zadanie skrapowania do filtrowania",
  selectTask: "— Wybierz zadanie —",
  task: "Zadanie",
  loadingTasks: "Ładowanie zadań...",
  failedToLoadTasks: "Nie udało się załadować zadań.",
  done: "gotowe",
  filteringResultsFrom: "Filtrowanie wyników z zadania",

  // Konstruktor filtrów
  filterBuilder: "Konstruktor filtrów",
  filterBuilderDesc: "Ustaw warunki dołączania lub wykluczania wyników",
  allConditions: "Wszystkie warunki",
  anyCondition: "Dowolny warunek",
  allConditionsDesc: "Wszystkie warunki muszą być spełnione, aby wynik przeszedł",
  anyConditionDesc: "Przynajmniej jeden warunek musi być spełniony, aby wynik przeszedł",
  addRule: "Dodaj regułę",
  clearAllRules: "Wyczyść wszystkie reguły",

  // Filtrowanie AI
  aiFiltering: "Filtrowanie AI",
  enable: "Włącz",
  availablePlaceholders: "Dostępne zmienne",
  aiPrompt: "Polecenie AI",
  aiPromptPlaceholder: "Opisz, jakie wyniki powinny przejść przez filtr...",
  testPrompt: "Testuj polecenie",
  matchCondition: "Warunek dopasowania",
  matchConditionDesc: "Odpowiedź AI musi zawierać to słowo/frazę, aby przejść",
  wordToMatchPlaceholder: "np. tak",
  entireText: "Cały tekst",
  firstLineOnly: "Tylko pierwsza linia",

  // Błędy walidacji
  selectTaskFirst: "Najpierw wybierz zadanie",
  enterTaskName: "Wprowadź nazwę zadania",
  enterAiPrompt: "Wprowadź polecenie AI",
  configureScrapingFirst: "Najpierw skonfiguruj skrapowanie",
  enterSearchQueries: "Wprowadź zapytania wyszukiwania",
  selectPlatform: "Wybierz platformę",
  unknownError: "Nieznany błąd",

  // Domyślne nazwy zadań
  scrapingFilteringTaskDefault: "Zadanie skrapowania + filtrowania",
  filterPrefix: "Filtr",
  taskPrefix: "Zadanie",

  // Kredyty
  estimatedTokens: "Szacowana liczba tokenów (w przybliżeniu)",

  // Przyciski
  creating: "Tworzenie...",
  createScrapingFilteringTask: "Utwórz zadanie skrapowania + filtrowania",
  createTask: "Utwórz zadanie",
  cancel: "Anuluj"
},
      
      instagram_reels: {
  // Prompty
  promptPart1FilterOnly: "Przeanalizuj ten Instagram Reel.\n\nOdpowiedz w dokładnie tym formacie:\nLinia 1: 'tak' lub 'nie'\n\n",
  promptPart1DescOnly: "Obejrzyj ten film Instagram Reel i podaj szczegółowy opis tego, co się w nim dzieje.\n\nOpisz:\n- Treść wizualną (sceny, obiekty, osoby)\n- Czynności i aktywności\n- Tekst widoczny w filmie\n- Dźwięk/muzykę (jeśli można zidentyfikować)\n- Ogólny nastrój i styl\n\nPodaj wyczerpujący opis w 3-5 zdaniach.\n\n",
  promptPart1FilterAndDesc: "Przeanalizuj ten Instagram Reel.\n\nOdpowiedz w dokładnie tym formacie:\nLinia 1: 'tak' lub 'nie'\nLinia 2+: Szczegółowy opis tego, co dzieje się w reelu\n\n",
  promptPart3PassCondition: 'WAŻNE: Wynik przechodzi TYLKO jeśli odpowiedź zawiera "{word}"',

  // Krok 1: Metryki
  step1MetricsFilter: "Krok 1: Filtr metryk",
  metricsFilterDesc: "Filtruj reele według wyświetleń, polubień, komentarzy i wskaźnika zaangażowania",
  minViews: "Min. wyświetleń",
  maxViews: "Maks. wyświetleń",
  minLikes: "Min. polubień",
  maxLikes: "Maks. polubień",
  minComments: "Min. komentarzy",
  maxComments: "Maks. komentarzy",

  // Krok 2: Filtrowanie AI
  step2AiFiltering: "Krok 2: Filtrowanie AI",
  aiFilteringDesc: "AI sklasyfikuje każdy reel na podstawie Twoich kryteriów",
  filterMethods: "Metody filtrowania",
  filterMethodsDesc: "Wybierz jedną lub więcej metod analizy reeli przez AI. Możesz łączyć wiele metod.",
  selectAtLeastOneMethod: "⚠️ Wybierz co najmniej jedną metodę filtrowania powyżej",
  yourPrompt: "Twój prompt filtrujący",
  aiPromptPlaceholder: "Co AI powinno sprawdzić?",
  availablePlaceholders: "Dostępne symbole zastępcze dla wybranych metod",
  matchCondition: "Warunek zaliczenia",
  matchConditionDesc: "Reel przechodzi filtr, jeśli odpowiedź AI zawiera to słowo",
  wordToMatchPlaceholder: "np. tak",
  filterPromptPreview: "Podgląd promptu filtrującego",

  // Krok 3: Sortowanie
  step3Sorting: "Krok 3: Sortowanie i selekcja",
  sortingDesc: "Wybierz najlepsze reele na podstawie zaangażowania",
  engagementFormula: "Formuła zaangażowania",
  standardFormula: "Standardowa",
  simpleFormula: "Prosta",
  standardFormulaDesc: "polubienia/wyświetlenia + (komentarze × 2)/wyświetlenia",
  simpleFormulaDesc: "polubienia/wyświetlenia",
  sortBy: "Sortuj według",
  byEngagement: "Zaangażowania",
  byLikes: "Polubień",
  byComments: "Komentarzy",
  topReelsCount: "Liczba najlepszych reeli",

  // Krok 4: Generowanie opisu
  step4GenerateDescription: "Krok 4: Generowanie opisu",
  generateDescriptionDesc: "AI obejrzy każdy reel i wygeneruje szczegółowy opis jego treści",
  descriptionAppliedToTop: "📌 Opisy zostaną wygenerowane tylko dla {count} najlepszych reeli (na podstawie ustawień sortowania w Kroku 3).",
  videoAnalysisCost: "Koszt analizy wideo",
  videoAnalysisCostDesc: "AI obejrzy rzeczywistą treść wideo każdego reela.\n\nKoszt: ~{tokens} tokenów na minutę wideo.\nDla przeciętnego 30-sekundowego reela: ~{estimated} tokenów.\nŁącznie dla {count} najlepszych reeli: ~{total} tokenów.",
  descriptionHowItWorks: "AI przeanalizuje rzeczywistą treść wideo (klatki wizualne, sceny, obiekty, czynności, tekst w filmie) i wygeneruje szczegółowy opis tekstowy tego, co dzieje się w reelu.",
  descPromptPreview: "Podgląd promptu opisu",
  descriptionForSummary: "Wygenerowane opisy zostaną użyte jako dane wejściowe dla Podsumowania AI w Kroku 5.",

  // Krok 5: Podsumowanie
  step5Summary: "Krok 5: Podsumowanie AI",
  summaryDesc: "Wygeneruj podsumowanie AI najlepszych reeli",
  needDescriptionWarning: "⚠️ Najpierw włącz generowanie opisu w Kroku 4",
  summaryDataFlow: "Podsumowanie otrzymuje opisy + metryki zaangażowania dla każdego najlepszego reela",
  summaryPrompt: "Prompt podsumowania",
  summaryPromptPlaceholder: "Dostosuj sposób podsumowania przez AI...",
  defaultSummaryPrompt: "Przeanalizuj te najlepsze Reele i stwórz wyczerpujące podsumowanie.\n\nDla każdego reela weź pod uwagę:\n- Opis treści\n- Metryki zaangażowania (wyświetlenia, polubienia, komentarze)\n- Wskaźnik zaangażowania\n- Kluczowe wzorce i trendy\n\nPodaj:\n1. Ogólne trendy we wszystkich reelach\n2. Wspólne cechy najlepszych\n3. Rekomendacje dotyczące strategii treści",

  // Koszty
  scrapingCost: "Scraping",
  aiCost: "Tokeny AI",
  queries: "zapytań",
  pages: "stron",
  reels: "reeli",
  tokens: "tokenów",

  step4GenerateDescription: "Krok 4: Generowanie opisu",
  generateDescriptionDesc: "AI obejrzy każdy reel i wygeneruje szczegółowy opis jego treści",
  descriptionAppliedToTop: "📌 Opisy zostaną wygenerowane tylko dla {count} najlepszych reeli (na podstawie ustawień sortowania w Kroku 3).",
  videoAnalysisCost: "Koszt analizy wideo",
  videoAnalysisCostDesc: "Koszt: ~{tokens} tokenów na minutę wideo.\nDla przeciętnego 30-sekundowego reela: ~{estimated} tokenów.\nŁącznie dla {count} najlepszych reeli: ~{total} tokenów.",
  descriptionHowItWorks: "AI przeanalizuje rzeczywistą treść wideo (klatki wizualne, sceny, obiekty, czynności, tekst w filmie) i wygeneruje szczegółowy opis tekstowy tego, co dzieje się w reelu.",
  descPromptPreview: "Podgląd promptu opisu",
  
  // Krok 5
  step5Summary: "Krok 5: Podsumowanie AI",
  summaryDesc: "Wygeneruj podsumowanie AI najlepszych reeli",
  needDescriptionWarning: "⚠️ Najpierw włącz generowanie opisu w Kroku 4",
  summaryDataFlow: "Podsumowanie otrzymuje opisy + metryki zaangażowania dla każdego najlepszego reela",
  summaryPrompt: "Prompt podsumowania",
  summaryPromptPlaceholder: "Dostosuj sposób podsumowania przez AI...",
  defaultSummaryPrompt: "Przeanalizuj te najlepsze Reele i stwórz wyczerpujące podsumowanie.\n\nDla każdego reela weź pod uwagę:\n- Opis treści\n- Metryki zaangażowania (wyświetlenia, polubienia, komentarze)\n- Wskaźnik zaangażowania\n- Kluczowe wzorce i trendy\n\nPodaj:\n1. Ogólne trendy we wszystkich reelach\n2. Wspólne cechy najlepszych\n3. Rekomendacje dotyczące strategii treści",
},



},

  
  visualizationTemplate: {
      
  
  keyword: "Słowo kluczowe",
  instagramPost: "Post na Instagramie",
  instagramPage: "Strona na Instagramie",
  facebookPost: "Post na Facebooku",
  facebookPage: "Strona na Facebooku",
  linkedinPost: "Post na LinkedIn",
  result: "Wynik",
  username: "Nazwa użytkownika",
  caption: "Podpis",
  bio: "Bio",
  followers: "Obserwujący",
  following: "Obserwowani",
  posts: "Posty",
  likes: "Liczba polubień",
  comments: "Liczba komentarzy",
  shares: "Udostępnienia",
  content: "Treść",
  headline: "Nagłówek",
  description: "Opis",
  category: "Kategoria",
  email: "E-mail",
  phone: "Telefon",
  website: "Strona internetowa",
  address: "Adres",
  name: "Nazwa",
  url: "Adres URL",
  imageUrl: "Adres URL obrazu",
  postUrl: "Adres URL posta",
  pageUrl: "Adres URL strony",
  postCode: "Kod pocztowy",
  scrapedUrl: "Zescrapowany adres URL",
  scrapedAt: "Data zescrapowania",
  foundViaUrl: "Znaleziono przez adres URL",
  searchPosition: "Pozycja w wyszukiwaniu",
  viaPost: "Przez post",
  status: "Status",
  date: "Data",
  noDescription: "Brak opisu",
  postImage: "Obraz posta",
  postContent: "Treść posta",
  postInfo: "Informacje o poście",
  engagement: "Zaangażowanie",
  author: "Autor",
  foundVia: "Znaleziono przez",
  profile: "Profil",
  pageStats: "Statystyki strony",
  details: "Szczegóły",
  contactInfo: "Dane kontaktowe",
  published: "Opublikowano",
  rawData: "Surowe dane",
  rawJson: "Surowy JSON",
  scraped: "Zescrapowano",
  hasPhone: "Posiada telefon",
  hasEmail: "Posiada e-mail",
  usernameInstagramPost: "Nazwa użytkownika właściciela",
  textInstagramPost: "Treść posta na Instagramie",
  instagram_profile_username: "Nazwa użytkownika profilu",
  instagram_profile_bio: "Bio profilu",
  instagram_profile_followers: "Liczba obserwujących",
  instagram_profile_following: "Liczba obserwowanych",
  instagram_profile_posts: "Liczba postów",
  instagram_profile_fullname: 'Pełna nazwa',

  facebook_post_text: "Treść posta na Facebooku",
  facebook_page_name: "Nazwa strony",
  facebook_page_description: "Opis strony",
  linkedin_post_author: "Autor posta",
  linkedin_post_headline: "Nagłówek posta",
  linkedin_post_content: "Treść posta",
  linkedin_post_shares: "Liczba udostępnień",
},


tasksListPage: {
    // General
    myTasks: "Moje zadania",
    active: "aktywne",
    total: "łącznie",
    running: "w trakcie",
    complete: "ukończone",
    newTask: "Nowe zadanie",
    delete: "Usuń",
    deleteConfirm: "Czy na pewno chcesz usunąć to zadanie?",
    edit: "Edytuj",

folders: {
  folders: "Foldery",
  organizeTasks: "Organizuj swoje zadania",
  newFolder: "Nowy folder",
  createFolder: "Utwórz folder",
  renameFolder: "Zmień nazwę folderu",
  folderNamePlaceholder: "Wpisz nazwę folderu...",
  cancel: "Anuluj",
  save: "Zapisz",
  saving: "Zapisywanie...",
  addTasks: "Dodaj zadania",
  addTasksToFolder: "Dodaj zadania do folderu",
  searchTasks: "Szukaj zadań...",
  noTasksFound: "Nie znaleziono zadań",
  noAvailableTasks: "Brak dostępnych zadań",
  selected: "wybrano",
  add: "Dodaj",
  adding: "Dodawanie...",
  deleteFolderConfirm: "Usunąć ten folder? Zadania nie zostaną usunięte.",
  deleteTaskConfirm: "Usunąć to zadanie?",
  duplicateFolder: "Duplikuj folder",
  removeFromFolder: "Usuń z folderu",
  removeFromFolderConfirm: "Usunąć zadanie z folderu?",
  root: "Główny",
  tasks: "zadania",
  subfolders: "podfoldery",
  tasksInFolder: "Zadania w tym folderze",
  folderEmpty: "Ten folder jest pusty",
  noFolders: "Brak folderów",
  createFirstFolder: "Utwórz pierwszy folder, aby organizować zadania",
  renameTaskPrompt: "Zmień nazwę zadania:",
},
    
createFilter: "Utwórz filtr",
  export: {
    title: "Eksportuj wyniki",
    format: "Format",
    options: "Opcje",
    pretty: "Czytelny JSON",
    prettyDesc: "Sformatowany dla łatwego czytania",
    dataType: "Typ danych",
    filteringData: "Wyniki filtrowania",
    parseData: "Wyniki parsowania",
    statusFilter: "Filtr statusu",
    successOnly: "Tylko udane",
    allResults: "Wszystkie wyniki",
    jsonDesc: "Pełne dane ze wszystkimi informacjami",
    urlsDesc: "Tylko adresy URL w pliku tekstowym",
    csvDesc: "Format tabelaryczny dla Excel",
    cancel: "Anuluj",
    export: "Eksportuj",
    exporting: "Eksportowanie...",
    exportResults: "Eksportuj wyniki",
    notAuthenticated: "Nie uwierzytelniono",
  },
  keywordStats: {
  title: "Statystyki słów kluczowych",
  subtitle: "Statystyki zaliczonych filtrów według słów kluczowych",
  keyword: "Słowo kluczowe",
  searchPeriod: "Okres wyszukiwania",
  lastPage: "Ostatnia strona",
  passed: "Zaliczone",
  noStats: "Brak dostępnych statystyk",
  noStatsDesc: "Statystyki pojawią się po zakończeniu filtrowania",
},
  rename: {
    label: 'Zmień nazwę',
    cancel: "Anuluj",
    saving: "Zapisywanie...",
    save: "Zapisz",
    renamePlaceholder: "Nazwa zadania",
    renameTaskDesc: "Wprowadź nową nazwę dla tego zadania",
    renameTask: "Zmień nazwę zadania"
  },

  
    duplicate: "Duplikuj",
    createFilteringTask: "Utwórz zadanie filtrowania",
    moreActions: "Więcej akcji",
    start: "Start",
    stop: "Zatrzymaj",
    visualization: "Wizualizacja",
    checkResults: "Wyniki",
    results: "Wyniki",
    noReports: "Brak raportów",
    reportsWillAppear: "Raporty pojawią się tutaj po ich wygenerowaniu",
    resultsTitle: "Wyniki i raporty",
    openReport: "Otwórz",
    untitled: "Bez nazwy",
    unknown: "Nieznany",
    
    // Task types
    filtering: "Filtrowanie",
    scraping: "Scraping",
    scrapingAndFiltering: "Scraping + Filtrowanie",
    
    // Platform specific
    authorPagesLabel: "Strony autorów",
    links: "linki",
    items: "elementy",
    jobsCompleted: "zadań ukończonych",
    failed: "Błędy",
    
    // Filtering Configuration
    filteringConfig: "Konfiguracja filtrowania",
    aiFilteringEnabled: "Filtrowanie AI włączone",
    aiFilteringDisabled: "Filtrowanie AI wyłączone",
    passKeyword: "Słowo kluczowe przepustki",
    checkFirstRowOnly: "Sprawdzaj tylko pierwszy wiersz",
    allRules: "Wszystkie reguły muszą pasować",
    anyRule: "Dowolna reguła może pasować",
    filterRules: "Reguły filtrowania",
    aiPrompt: "Prompt AI",
    
    // Filtering Results
    filteringResults: "Wyniki filtrowania",
    totalRuns: "Wszystkich uruchomień",
    doneFilter: "Gotowe",
    runningFilter: "W trakcie",
    pendingFilter: "Oczekujące",
    passedFilter: "Przeszło",
    rejectedFilter: "Odrzucone",
    failedFilter: "Błędy",
    ofTotal: "z całości",
    aiResults: "Wyniki AI",
    aiPassed: "AI przepuściło",
    aiRejected: "AI odrzuciło",
    
    // Scraping Statistics
    scrapingStats: "Statystyki scrapingu",
    googleJobs: "Zadania Google",
    scrapedLinks: "Zesrapowane linki",
    found: "Znalezione",
    stage: "Etap",
    completed: "Ukończone",
    
    // Search Configuration
    keywords: "Słowa kluczowe",
    searchConfig: "Konfiguracja wyszukiwania",
    maxPages: "Maks. stron",
    additionalSettings: "Dodatkowe ustawienia",
    scrapeAuthorPages: "Scrapuj strony autorów",
    enabled: "Włączone",
    disabled: "Wyłączone",
    authorPagesEnabledDesc: "Jeśli otrzymamy link do posta/relacji w Google, pobierzemy informacje o autorze",
authorPagesDisabledDesc: "Jeśli otrzymamy link do posta/relacji w Google, nie będziemy ich sprawdzać",

    // Timestamps
    created: "Utworzono",
    started: "Rozpoczęto",
    updated: "Zaktualizowano",
    finished: "Zakończono",
    
    // Error states
    failedToLoadTasks: "Nie udało się załadować zadań",
    retry: "Spróbuj ponownie",
    notAuthenticated: "Nie uwierzytelniony",
    fetchFailed: "Nie udało się pobrać zadań",
    
    // Queue notice
    queueNotice: "Zadania są przetwarzane w kolejce.",
    topUpBalance: "Doładuj saldo",
    fasterProcessing: "dla szybszego przetwarzania. Otrzymasz e-mail, gdy zadanie zostanie ukończone.",
    
    // Show more/less
    showAll: "Pokaż wszystkie",
    showLess: "Pokaż mniej",
    more: "więcej",
    valuesCount: "wartości",
    
    // Filter operators
    containsAny: "Zawiera którekolwiek",
    containsAnyOf: "Zawiera którekolwiek z",
    excludesAll: "Wyklucza wszystkie",
    excludesAllOf: "Wyklucza wszystkie z",
    isNotEmpty: "Nie jest pusty",
    isTrue: "Jest prawdą",
    isFalse: "Jest fałszem",
    equals: "Równa się",
    contains: "Zawiera",
    doesNotContain: "Nie zawiera",
    greaterThan: "Większe niż {{val}}",
    lessThan: "Mniejsze niż {{val}}",
    between: "Między {{min}} a {{max}}",
    
    // Token/force stop
    noAITokens: "Brak tokenów AI",
    noScrapingTokens: "Brak tokenów scrapingu",
    noAITokensTitle: "Wyczerpano tokeny AI",
    noScrapingTokensTitle: "Wyczerpano tokeny scrapingu",
    topUp: "Doładuj",
    paused: "Wstrzymane",
    
    // Reels Configuration
    reelsConfig: "Konfiguracja Reels",
    sortBy: "Sortuj według",
    topReels: "Top",
    engagementFormula: "Formuła",
    metricsFiltering: "Filtrowanie metryk",
    aiSummary: "Podsumowanie AI",
    metricsFilter: "Filtry metryk",
    minViews: "Min. wyświetleń",
    maxViews: "Max. wyświetleń",
    minLikes: "Min. polubień",
    maxLikes: "Max. polubień",
    minComments: "Min. komentarzy",
    maxComments: "Max. komentarzy",
    minEngagement: "Min. zaangażowania",
    maxEngagement: "Max. zaangażowania",
    filteringPrompt: "Prompt filtrowania AI",
    summaryPrompt: "Prompt podsumowania AI",
    
    // Status labels
    done: "Gotowe",
    completed: "Ukończone",
    pending: "Oczekujące",
    
    // Time
    justNow: "Przed chwilą",
    minutesAgo: "{{count}} min temu",
    hoursAgo: "{{count}} godz. temu",
    daysAgo: "{{count}} dni temu",
    
    // Periods
    periodHour: "Godzina",
    periodDay: "Dzień",
    periodWeek: "Tydzień",
    periodMonth: "Miesiąc",
    periodYear: "Rok",
    periodAny: "Dowolny",
    
    // Platforms
    instagramPages: "Strony Instagram",
    instagramPosts: "Posty Instagram",
    instagramReels: "Instagram Reels",
    facebookPosts: "Posty Facebook",
    facebookPages: "Strony Facebook",
    linkedinPosts: "Posty LinkedIn",
    
    // Verification banner (if needed)
    verifyBanner: "Zweryfikuj swój email:",
    verifyBanner2: "aby odblokować wszystkie funkcje.",
    resendVerify: "Wyślij ponownie",
  },



};